import React from "react";

import useTranslation from "next-translate/useTranslation";
import { AiOutlineShoppingCart } from "react-icons/ai";
import { FiAlertCircle } from "react-icons/fi";

import { useGlobalContext } from "shared/utils/hooks/useGlobalContext";

import {
  AppPurchaseDisableContainer,
  AppPurchaseDisableContent,
  BtnText,
  Title,
} from "./styles";

const AppPurchaseDisable = () => {
  const { t } = useTranslation();
  const { setState } = useGlobalContext();

  function handleShowPurshaceDisableModal() {
    setState((prev) => ({ ...prev, showDisablePurchaseModal: true }));
  }

  return (
    <AppPurchaseDisableContainer>
      <Title>
        <AiOutlineShoppingCart />
        {t("common:purchaseAvailable")}
      </Title>
      <AppPurchaseDisableContent onClick={handleShowPurshaceDisableModal}>
        <BtnText>
          <FiAlertCircle />
          {t("common:howDoIWatch")}
        </BtnText>
      </AppPurchaseDisableContent>
    </AppPurchaseDisableContainer>
  );
};

export default AppPurchaseDisable;
